import { ArrowsAltOutlined } from '@ant-design/icons';
import React from 'react';
import { MapRef } from 'react-map-gl';
import { OmniaButton } from '../../../omnia_button/omnia_button';
import styles from './modal_no_lakes.less';

interface ModalNoLakesProps {
  mapRef: MapRef;
  onClick: () => void;
}

export const ModalNoLakes = (props: ModalNoLakesProps) => {
  const { mapRef, onClick } = props;
  return (
    <>
      <li className={styles.noReportsBlurb}>
        <strong>For this map area we didn't find any lakes.</strong>{' '}
        <OmniaButton
          size="md"
          kind="primary"
          onPress={() => {
            const currentZoom = mapRef.getZoom();
            mapRef.zoomTo(currentZoom - 3);
            onClick();
          }}
          className={styles.expandButton}
        >
          <ArrowsAltOutlined /> Expand Search Area
        </OmniaButton>
      </li>
    </>
  );
};
